import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import './Rightbar.less';
import { ColorPicker, Popover, Slider, Switch, Tooltip } from 'antd';
import caIcon from '@/assets/texture/ca.png';
import caResetIcon from '@/assets/texture/ca-reset.png';
import caCombineIcon from '@/assets/texture/ca-combine.png';

import closeIcon from '@/assets/texture/close.png';
import closeSelectedIcon from '@/assets/texture/closeSelected.png';

import caDeleteIcon from '@/assets/texture/delete.png';
import brushIcon from '@/assets/texture/brush.png';
import quanIcon from '@/assets/texture/quan.png';

import caSelectedIcon from '@/assets/texture/caSelected.png';
import caResetSelectedIcon from '@/assets/texture/ca-resetSelected.png';
// import caSelectedCombineIcon from '@/assets/texture/ca-combineSelected.png';

// import caSelectedDeleteIcon from '@/assets/texture/deleteSelected.png';
import brushSelectedIcon from '@/assets/texture/brushSelect.png';

import ColorAndPenPicker from '@/components/ColorAndPenPicker/ColorAndPenPicker';
import {
  adjustBrushSize,
  clearInpainting,
  deleteInpainting,
  inpaintDraw,
  inpaintErase,
  inpaintOriginal,
  OnBrushGroupChanged,
  OnDiscardLayers,
  onUVChanged,
} from '@/utils/unityTool';
import InpaintSvg from '@/components/InpaintSvg/InpaintSvg';
import { projectController } from '@/api';
import { useParams } from 'react-router-dom';
import { reportData } from '@/utils/trackingPoint';

export default forwardRef(function Rightbar(
  { sendMessage, onBrushIsPaint, images, onShowBanlanceModal },
  ref,
) {
  const { projectId } = useParams(); // 获取路径参数
  const [isSaving, setIsSaving] = useState(false);

  const [layer, setLayer] = useState(0);
  const [brushSize, setBrushSize] = useState(0.2);

  const [brush, setBrush] = useState(false);
  const [inpaintColor, setInpaintColor] = useState('#fff');

  const [brushGroupState, setBrushGroupState] = useState(-1);
  const [uvExpand, setUvExpand] = useState(false);

  const [switchLayerErase, setSwitchLayerErase] = useState(false);
  const [switchLayerRecorver, setSwitchLayerRecorver] = useState(false);
  const [layerCombine, setLayerCombine] = useState(false);
  const [discardLayersEnable, setDiscardLayersEnable] = useState(true);

  const [isInpaint, setIsInpaint] = useState(false);

  const [onInpaint, setOnInpaint] = useState(false);
  const [onInpaintErase, setOnInpaintErase] = useState(false);
  const [reset, setReset] = useState(false);
  const [matIndex, setMatIndex] = useState(0);

  const [setPenColor, setSetPenColor] = useState(false);
  const [models, setModels] = useState([]);

  const [colorAndPenPickerOpen, setColorAndPenPickerOpen] = useState(false);
  const [sizeOpen, setSizeOpen] = useState(false);

  const timeoutRef = useRef(null);
  const timeoutSizeRef = useRef(null);

  const [uvChanged, setUvChanged] = useState(0);
  const [fade, setFade] = useState(1);
  const [colorAndPenPickerKey, setColorAndPenPickerKey] = useState(1);

  const [isInpaintGenerate, setIsInpaintGenerate] = useState(false);

  // 3秒自动关闭逻辑
  const openPopover = () => {
    if (onInpaint) {
      clearTimeout(timeoutRef.current);
      setColorAndPenPickerOpen(true);
    }
  };

  const closePopoverDelayed = () => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setColorAndPenPickerOpen(false);
    }, 2000);
  };

  const cancelClose = () => {
    clearTimeout(timeoutRef.current);
  };

  // 3秒自动关闭逻辑
  const openSizePopover = () => {
    if (brush) {
      clearTimeout(timeoutSizeRef.current);
      setSizeOpen(true);
    }
  };

  const closeSizePopoverDelayed = () => {
    clearTimeout(timeoutSizeRef.current);
    timeoutSizeRef.current = setTimeout(() => {
      setSizeOpen(false);
    }, 2000);
  };

  const cancelSizeClose = () => {
    clearTimeout(timeoutSizeRef.current);
  };

  useImperativeHandle(ref, () => ({
    resetValues() {
      // setUvChanged(0);
      // setFade(10);
      // sendMessage('ContextManager', 'OnCmdExec', 'OnUVChanged 0');
      // sendMessage('ContextManager', 'OnCmdExec', 'OnFadeSliderChanged 10');

      setBrush(false);
      setSwitchLayerErase(false);
      setSwitchLayerRecorver(false);
      setOnInpaintErase(false);
      setOnInpaint(false);
      setColorAndPenPickerOpen(false);
      setUvExpand(false);
      // setColorAndPenPickerKey(colorAndPenPickerKey + 1);
      sendMessage('ContextManager', 'OnCmdExec', 'OnMatChanged 0');
    },
    //生成完成
    onGenerateFinish(isInpaintGenerate) {
      setIsInpaintGenerate(isInpaintGenerate);
      // 这一行代码可以导致一个大bug，导致第二次问生图，笔刷图层还在,需要判断是否是笔刷模式
      if (isInpaintGenerate) {
        setFade(1);
        // sendMessage('ContextManager', 'OnCmdExec', 'OnFadeSliderChanged ' + 10);
      }
    },
    //生成完成
    settingIsSaving(val) {
      setIsSaving(val);
    },
    //生成完成
    settingEnableButtons(val) {
      setEnableButtons(val);
    },
  }));

  const downloadTexture = async () => {
    reportData('export');
    if (isSaving) {
      return;
    }
    let res = await projectController.download({
      projectId,
    });
    if (res.code === 0) {
      sendMessage('ContextManager', 'OnCmdExec', 'OnTextureSave');
    } else {
      // message.error('Insufficient balance, please recharge.', {
      //   id: 'only',
      // });
      onShowBanlanceModal();
    }
  };

  useEffect(() => {
    window.onUnityMatChanged = (index) => {
      setMatIndex(index * 1);
      if (index !== 0) {
        setUvExpand(false);
      }
    };
    window.OnLayerCombined = (isOn) => {};
  }, []);

  const changeBrushState = (state) => {
    // if (state != brushGroupState && brushGroupState != -1) {
    //   console.log('OnBrushGroupChanged', brushGroupState);
    //   OnBrushGroupChanged(sendMessage, brushGroupState, false);
    // }
    // setBrushGroupState(state);
  };
  // 获取按钮组是否可点击
  const getEnableButtons = () => {
    return matIndex === 0 && !uvExpand;
  };
  const switchUvExpand = (value) => {
    if (matIndex === 0) {
      setUvExpand(value);
      if (value) {
        onUVChanged(sendMessage, true);
      } else {
        onUVChanged(sendMessage, false);
      }
    }
  };

  const changeInpaint = (value) => {
    if (!value) {
      setSizeOpen(true);
      onBrushIsPaint(true);
      setIsInpaint(true);
      setBrush(true);
      setOnInpaint(false);
      setSwitchLayerRecorver(false);
      setSwitchLayerErase(false);
      setOnInpaintErase(false);
      setColorAndPenPickerOpen(false);
      changeBrushState(0);
    } else {
      setBrush(false);
      onBrushIsPaint(false);
      setIsInpaint(false);
      setBrushGroupState(-1);
      setSizeOpen(false);
    }
    inpaintOriginal(sendMessage, brush);
  };
  return (
    <div
      className="right-bar"
      onClick={() => {
        setColorAndPenPickerOpen(false);
      }}>
      <div className="right-bar-content scrollbar-thin scrollbar-track-transparent">
        <div className="right-bar-content-wrapper">
          <div className="title">Layer Tools</div>
          <div className="layer-tools">
            <Tooltip title="Layer Eraser">
              <div
                onClick={() => {
                  reportData('click-eraser');
                  if (!switchLayerErase) {
                    onBrushIsPaint(true);
                    setIsInpaint(true);
                    setSwitchLayerErase(true);
                    setSwitchLayerRecorver(false);
                    setBrush(false);
                    setOnInpaintErase(false);
                  } else {
                    setSwitchLayerErase(false);
                  }

                  setBrush(false);
                  setOnInpaint(false);
                  onBrushIsPaint(false);
                  setIsInpaint(false);

                  sendMessage(
                    'ContextManager',
                    'OnCmdExec',
                    'OnLayerErase ' + (switchLayerErase ? 0 : 1),
                  );
                }}
                className={
                  'layer-item ' +
                  (switchLayerErase
                    ? 'selected'
                    : '' + (getEnableButtons() ? '' : 'disable-button'))
                }>
                <img src={switchLayerErase ? caSelectedIcon : caIcon}></img>
              </div>
            </Tooltip>
            <Tooltip title="Layer Recorver">
              <div
                onClick={() => {
                  reportData('click-reeraser');
                  if (!switchLayerRecorver) {
                    onBrushIsPaint(true);
                    setIsInpaint(true);
                    setSwitchLayerRecorver(true);
                    setSwitchLayerErase(false);
                    setBrush(false);
                    setOnInpaintErase(false);
                  } else {
                    setSwitchLayerRecorver(false);
                  }
                  setBrush(false);
                  setOnInpaint(false);
                  onBrushIsPaint(false);
                  setIsInpaint(false);
                  sendMessage(
                    'ContextManager',
                    'OnCmdExec',
                    'OnLayerRecover ' + (switchLayerRecorver ? 0 : 1),
                  );
                }}
                className={
                  'layer-item ' +
                  (switchLayerRecorver ? 'selected' : '') +
                  (getEnableButtons() ? '' : 'disable-button')
                }>
                <img src={switchLayerRecorver ? caResetSelectedIcon : caResetIcon}></img>
              </div>
            </Tooltip>
            <Tooltip title="Combine Layer">
              <div
                onClick={() => {
                  reportData('click-combine');
                  // if (!layerCombine) {
                  //   setLayerCombine(true);
                  //   setSwitchLayerRecorver(false);
                  //   setSwitchLayerErase(false);
                  //   setBrush(false);
                  //   setOnInpaint(false);
                  // } else {
                  //   setLayerCombine(false);
                  // }
                  sendMessage('ContextManager', 'OnCmdExec', 'OnLayerCombine 1');
                }}
                className={'layer-item ' + (getEnableButtons() ? '' : 'disable-button')}>
                <img src={caCombineIcon}></img>
              </div>
            </Tooltip>
            <Tooltip title="Clear Layers">
              <div
                onClick={() => {
                  reportData('click-droplayer');
                  OnDiscardLayers(sendMessage);
                }}
                className={'layer-item ' + (getEnableButtons() ? '' : 'disable-button')}>
                <img src={closeIcon}></img>
              </div>
            </Tooltip>
          </div>

          <div className="title">Brush Tools</div>
          <div className="brush-wrapper">
            <div className="brush-tools">
              <Popover
                placement="bottom"
                color="#222"
                style={{ padding: 0, backgroundColor: '#313131' }}
                open={sizeOpen}
                content={
                  <div onMouseEnter={cancelSizeClose} onMouseLeave={closeSizePopoverDelayed}>
                    <ColorAndPenPicker
                      showColor={false}
                      size={brushSize}
                      sendMessage={sendMessage}
                      onSizeChange={(v) => {
                        setBrushSize(v);
                      }}></ColorAndPenPicker>
                  </div>
                }
                title="">
                <Tooltip title="Inpaint Original">
                  <div
                    onMouseEnter={openSizePopover}
                    onMouseLeave={closeSizePopoverDelayed}
                    onClick={() => {
                      changeInpaint(brush);
                      reportData('click-pen');
                    }}
                    className={
                      'brush-item ' +
                      (brush ? 'selected' : '') +
                      (getEnableButtons() ? '' : 'disable-button')
                    }>
                    <img src={brush ? brushSelectedIcon : brushIcon}></img>
                  </div>
                </Tooltip>
              </Popover>
              <Popover
                color="#222"
                style={{ padding: 0, backgroundColor: '#313131' }}
                open={colorAndPenPickerOpen}
                content={
                  <div onMouseEnter={cancelClose} onMouseLeave={closePopoverDelayed}>
                    <ColorAndPenPicker
                      showColor={true}
                      size={brushSize}
                      sendMessage={sendMessage}
                      onColorChange={(v) => {
                        const color = typeof v === 'string' ? v : v.toHexString();
                        setInpaintColor(color);
                        sendMessage('ContextManager', 'OnCmdExec', 'SetPenColor ' + color);
                      }}
                      onSizeChange={(v) => {
                        setBrushSize(v);
                      }}></ColorAndPenPicker>
                  </div>
                }
                title="">
                <Tooltip title="Inpaint Draw">
                  <div
                    onMouseEnter={openPopover}
                    onMouseLeave={closePopoverDelayed}
                    onClick={(event) => {
                      reportData('click-colorpen');
                      event.stopPropagation();
                      if (!onInpaint) {
                        setBrush(false);
                        setOnInpaint(true);
                        onBrushIsPaint(true);
                        setColorAndPenPickerOpen(true);
                        setSwitchLayerRecorver(false);
                        setSwitchLayerErase(false);
                        setOnInpaintErase(false);
                        changeBrushState(1);
                        setSizeOpen(false);
                      } else {
                        setOnInpaint(false);
                        onBrushIsPaint(false);
                        setColorAndPenPickerOpen(false);
                        setBrushGroupState(-1);
                      }
                      inpaintDraw(sendMessage, onInpaint);
                    }}
                    className={
                      'brush-item ' +
                      (onInpaint ? 'selected ' : '') +
                      (getEnableButtons() ? '' : 'disable-button')
                    }>
                    <InpaintSvg color={inpaintColor}></InpaintSvg>
                    {/* <img src={onInpaint ? quanSelectedIcon : quanIcon}></img> */}
                  </div>
                </Tooltip>
              </Popover>
              <Tooltip title="Inpaint Erase">
                <div
                  onClick={() => {
                    setOnInpaintErase(!onInpaintErase);
                    onBrushIsPaint(false);
                    reportData('click-repen');
                    if (onInpaintErase == 0) {
                      setBrush(false);
                      setOnInpaint(false);
                      onBrushIsPaint(true);
                      setSwitchLayerRecorver(false);
                      setSwitchLayerErase(false);
                      changeBrushState(2);
                    } else {
                      setBrushGroupState(-1);
                    }
                    inpaintErase(sendMessage, onInpaintErase == 0 ? 1 : 0);
                  }}
                  className={
                    'brush-item ' +
                    (onInpaintErase ? 'selected ' : '') +
                    (getEnableButtons() ? '' : 'disable-button')
                  }>
                  <img src={onInpaintErase ? caSelectedIcon : caIcon}></img>
                </div>
              </Tooltip>
              <Tooltip title="Clear Inpainting">
                <div
                  onClick={() => {
                    // onBrushIsPaint(false);
                    // setBrush(false);
                    // setOnInpaint(false);
                    // setOnInpaintErase(false);
                    // setSwitchLayerErase(false);
                    // setSwitchLayerRecorver(false);
                    clearInpainting(sendMessage);
                    reportData('click-droppen');
                  }}
                  className={'brush-item ' + (getEnableButtons() ? '' : 'disable-button')}>
                  <img src={caDeleteIcon}></img>
                </div>
              </Tooltip>
            </div>
            <div
              className={
                'delete-inpainting-button ' +
                (isInpaintGenerate ? '' : 'disabled ') +
                (getEnableButtons() ? '' : 'disable-button')
              }
              onClick={() => {
                reportData('click-deletepen');
                if (isInpaintGenerate) {
                  setIsInpaintGenerate(false);
                  deleteInpainting(sendMessage);
                }
              }}>
              Delete Inpainting
            </div>
          </div>

          {/* <div
            className="reset-inpainting-button"
            onClick={() => {
              sendMessage('ContextManager', 'OnCmdExec', 'reset');
            }}>
            Reset
          </div> */}

          <div className="preview">
            <div className="title">Texture Preview</div>
            <div style={{ flex: 1 }}></div>

            <div className={'switch-uv ' + (matIndex === 0 ? '' : 'disable-switch-button')}>
              <div
                className={'item i1 ' + (uvExpand ? 'active' : '')}
                onClick={() => {
                  reportData('click-uvvision');
                  switchUvExpand(true);
                }}>
                UV
              </div>
              <div
                className={'item i2 ' + (!uvExpand ? 'active' : '')}
                onClick={() => {
                  reportData('click-3dvision');
                  switchUvExpand(false);
                }}>
                3D
              </div>
            </div>

            {/* <Switch
              disabled={matIndex !== 0}
              checkedChildren="2D"
              unCheckedChildren="3D"
              onChange={(val) => {
                if (val) {
                  sendMessage('ContextManager', 'OnCmdExec', 'OnUVChanged ' + 1);
                } else {
                  sendMessage('ContextManager', 'OnCmdExec', 'OnUVChanged ' + 0);
                }
              }}></Switch> */}
          </div>
          <div className={'preview-images ' + (images && images.length > 1 ? '' : 'single')}>
            {images &&
              images.map((item, i) => {
                return (
                  <div key={i} className={'image '}>
                    <img src={item.data || item}></img>
                  </div>
                );
              })}
          </div>

          {/* <div className="slider-row">
            <div className="title">{matIndex === 1 ? 'Contrast' : 'No Content'}</div>
            <Slider
              min={0}
              max={1}
              style={{ flex: 1 }}
              step={0.05}
              value={uvChanged}
              disabled={matIndex !== 1}
              onChange={(value) => {
                setUvChanged(value);
                sendMessage('ContextManager', 'OnCmdExec', 'OnUVChanged ' + (1 - value));
              }}></Slider>
          </div> */}
          <div className="slider-row">
            <div className="title">Edge Fade</div>
            <Slider
              min={0}
              max={1}
              value={fade}
              disabled={!isInpaintGenerate}
              style={{ flex: 1 }}
              step={0.1}
              onChange={(value) => {
                setFade(value);
                reportData('feathering', {
                  'num-feathering': value,
                });

                setTimeout(() => {
                  sendMessage('ContextManager', 'OnCmdExec', 'OnFadeSliderChanged ' + value);
                });
              }}></Slider>
          </div>
        </div>
      </div>
      <div
        className={'download-button ' + (isSaving ? 'disabled' : '')}
        onClick={() => {
          downloadTexture();
        }}>
        Export Texture
      </div>
    </div>
  );
});
